import { ValidationError } from "@/types/errors";

export const parseErrorMessage = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: any | ValidationError[],
): string | null => {
  if (!Array.isArray(errors) || errors.length === 0) {
    return null;
  }

  if (typeof errors[0].msg === "string") {
    return errors[0].msg.replace("Value error, ", "");
  }

  return (errors as ValidationError[])
    .map(error => {
      const location = error.loc.join(" > ");
      return `Error in ${location}: ${error.msg}`;
    })
    .join("\n");
};

/** Extract a user-visible message from a React Query / fetch mutation error. */
export const formatMutationError = (error: unknown, fallback: string): string => {
  if (typeof error === "string" && error.trim()) {
    return error;
  }

  if (error && typeof error === "object") {
    const record = error as Record<string, unknown>;
    if (typeof record.message === "string" && record.message.trim()) {
      if (record.code === "break_glass_guardrail_blocked") {
        return `${record.message} Enroll MFA in Account Settings → Security, then retry.`;
      }
      return record.message;
    }
  }

  return fallback;
};
